import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

interface ExpectationsLabels {
  expectedPriceLabel: string;
  expectedPricePlaceholder: string;
  locationLabel: string;
  locationPlaceholder: string;
  commentLabel: string;
  commentPlaceholder: string;
  quickComment1: string;
  quickComment2: string;
  quickComment3: string;
}

interface ExpectationsSectionProps {
  expectedPrice: string;
  location: string;
  comment: string;
  onExpectedPriceChange: (value: string) => void;
  onLocationChange: (value: string) => void;
  onCommentChange: (value: string) => void;
  commentError?: string;
  labels: ExpectationsLabels;
}

export const ExpectationsSection = ({
  expectedPrice,
  location,
  comment,
  onExpectedPriceChange,
  onLocationChange,
  onCommentChange,
  commentError,
  labels,
}: ExpectationsSectionProps) => {
  const quickComments = [
    labels.quickComment1,
    labels.quickComment2,
    labels.quickComment3,
  ];
  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="expectedPrice">{labels.expectedPriceLabel}</Label>
        <Input
          id="expectedPrice"
          type="number"
          placeholder={labels.expectedPricePlaceholder}
          value={expectedPrice}
          onChange={(e) => onExpectedPriceChange(e.target.value)}
          min="0"
          step="1"
        />
      </div>
      <div>
        <Label htmlFor="location">{labels.locationLabel}</Label>
        <Input
          id="location"
          placeholder={labels.locationPlaceholder}
          value={location}
          onChange={(e) => onLocationChange(e.target.value)}
        />
      </div>
      <div>
        <Label htmlFor="comment" className="flex items-center">
          {labels.commentLabel} <span className="text-red-500 ml-1">*</span>
        </Label>
        <div className="flex flex-wrap gap-1 sm:gap-2 mb-2">
          {quickComments.map((q) => (
            <Button
              key={q}
              type="button"
              variant="outline"
              size="sm"
              className="text-xs whitespace-normal text-left h-auto py-2 px-2 sm:px-3"
              onClick={() => onCommentChange(q)}
            >
              {q}
            </Button>
          ))}
        </div>
        <Textarea
          id="comment"
          placeholder={labels.commentPlaceholder}
          value={comment}
          onChange={(e) => onCommentChange(e.target.value)}
          rows={3}
          required
        />
        {commentError && (
          <div className="text-red-500 text-xs mt-1">{commentError}</div>
        )}
      </div>
    </div>
  );
};
